import cc from "classcat"
import React from "react"

import styles from "./SmartMatchingScoreLabel.module.css"

import SmartMatch from "~/common/react-icons/smartMatch"

import { getScore } from "./helpers"

type Props = {
  score: number
  className?: string
  size?: "default" | "large"
}

const SCORE_CLASS_MAP = {
  great: styles.greatScore,
  good: styles.goodScore,
  fair: styles.fairScore,
  limited: styles.limitedScore,
} as const

const SCORE_ICON_COLORS = {
  great: "var(--white)",
  good: "var(--midnight)",
  fair: "var(--midnight)",
  limited: "var(--white)",
} as const

const SmartMatchingScoreLabel = ({
  score,
  className,
  size = "default",
}: Props) => {
  const scoreLevel = getScore(score)
  if (!scoreLevel) {
    return null
  }

  const scoreValue = scoreLevel.value
  const scoreClassName = SCORE_CLASS_MAP[scoreValue]
  const iconColor = SCORE_ICON_COLORS[scoreValue]
  const label = scoreLevel.label
  const sizeClassName = size === "large" ? styles.large : styles.default

  return (
    <div
      className={cc([
        styles.smartMatchScore,
        scoreClassName,
        sizeClassName,
        className,
      ])}
    >
      <SmartMatch color={iconColor} className={styles.smartMatchIcon} />
      <span className={styles.scoreText}>{label}</span>
    </div>
  )
}

export default SmartMatchingScoreLabel
